import type { SavedSyntenyView, SavedViewMetadata } from "../store/slices/save-load-slice.ts";
import { getClient } from "./openapi.ts";
import { throwErrors } from "./throw-errors.ts";

export async function postSavedView(metadata: SavedViewMetadata, state: SavedSyntenyView): Promise<number> {
  const client = getClient();
  const { data, error, response } = await client.POST("/view/synteny", {
    cache: "no-cache",
    body: {
      ...metadata,
      state,
    },
  });

  throwErrors(response, data, error);

  return data;
}

export async function fetchSavedView(viewId: number) {
  const client = getClient();
  const { data, error, response } = await client.GET("/view/synteny/{viewId}", {
    cache: "no-cache",
    params: { path: { viewId } },
  });

  throwErrors(response, data, error);
  return data;
}

export async function putSavedView(metadata: SavedViewMetadata, state: SavedSyntenyView): Promise<number> {
  const client = getClient();
  const { data, error, response } = await client.PUT("/view/synteny", {
    cache: "no-cache",
    body: {
      ...metadata,
      state,
    },
  });

  throwErrors(response, data, error);

  return data;
}
